'use strict';

export function updateQuery(query, name, value) {
    if (value === '') {
        delete query[name];
    } else {
        query[name] = value;
    }

    return query;
}

export function createUrlFromLocation(location) {
    return (
        location.pathname +
        Object.keys(location.query || {})
            .sort()
            .reduce((acc, name) => {
                return acc + (acc === '' ? '?' : '&') + name + '=' + encodeURIComponent(location.query[name]);
            }, '') +
        (location.hash ? location.hash : '')
    );
}

export function scrollTo(id) {
    const el = document.getElementById(id);

    if (el) {
        const { top } = el.getBoundingClientRect();
        document.body.scrollTop = document.documentElement.scrollTop =
            document.body.scrollTop + document.documentElement.scrollTop + top;
    }
}
